import { ReactNode } from "react";

interface LoaderProps {
  icon: ReactNode;
  animationDuration?: number;
  bgColor?: string;
  textColor?: string;
}

export default function Loader({
  icon,
  animationDuration = 6,
  bgColor = "",
  textColor = ""
}: LoaderProps) {
  return (
    <div
      className={`w-full flex flex-col text-[#5E5ADB] items-center justify-start gap-8 m-auto ${textColor}`}
    >
      {icon}
      <div className="relative bg-[#EAECF0] h-[8px] rounded-full w-[200px]">
        <div
          className={`bg-[#5E5ADB] h-[8px] rounded-full w-[0%] animate-progress ${bgColor}`}
          style={{ animationDuration: `${animationDuration}s` }}
        ></div>
      </div>
    </div>
  );
}
